import { BrowserConfig, initializeFaro } from '@grafana/faro-react';
import { SessionInstrumentation } from '@grafana/faro-web-sdk';
import { AppMeta } from 'src/types';

/**
 * Default Grafana Faro collector URL for PSC packages.
 * This value is configured to match the Grafana dashboard settings for this specific app.
 * It serves as the fallback URL when no custom URL is provided in the config.
 */
const PSC_PACKAGES_GRAFANA_URL =
  'https://faro-collector-prod-us-central-0.grafana.net/collect/8a9c27918383a9156922d9664d1970af';

/**
 * Configuration options for initializing the logger.
 */
export interface InitializeLoggerConfig extends Partial<Omit<BrowserConfig, 'url'>> {
  /**
   * Metadata that identifies the source of the log messages.
   */
  app: AppMeta;
  /**
   * Optional URL for the Grafana Faro collector endpoint.
   * If not provided, defaults to PSC_PACKAGES_GRAFANA_URL.
   */
  url?: string;
}

/**
 * Initializes the Grafana Faro logger with the provided configuration.
 *
 * @param config - Configuration options for the logger, including app metadata and optional URL
 */
export const initializeLogger = (config?: InitializeLoggerConfig): void => {
  const url = config?.url ?? PSC_PACKAGES_GRAFANA_URL;
  const extraInstrumentations = config?.instrumentations ?? [];

  initializeFaro({
    ...config,
    sessionTracking: {
      enabled: true,
      samplingRate: 1.0,
      persistent: false
    },
    isolate: true,
    url,
    instrumentations: [new SessionInstrumentation(), ...extraInstrumentations]
  });
};
